/**
 * Team, Reports (plan docs/plans/lms-plan.md 13 tab 6 "Reports (completion
 * rates per course and site over a date range; item analysis per course
 * version: per question the answer distribution and the miss rate, so a
 * question everyone misses is found; campaign outcomes; CSV exports)";
 * Appendix A "Reports"; 18.23; R16, R21, R23; WP-45).
 *
 * Replaces WP-03's placeholder in place: tabs/team/subviews.ts imports this
 * file's DEFAULT export (no props), mounted at /lms/team/reports/* (18.3).
 *
 * Three reports behind one segmented bar. The CSV exports of Appendix A are
 * the matrix's (Team, Matrix, "Export CSV") and the SOP acknowledgement file
 * (the SOPs tab tracker); api/reports.ts carries both calls.
 */
import { useState } from 'react';
import SegmentedTabs from '../../../../ui/SegmentedTabs';
import CampaignReportPanel from './CampaignReportPanel';
import CompletionRatesPanel from './CompletionRatesPanel';
import ItemAnalysisPanel from './ItemAnalysisPanel';

type ReportKey = 'rates' | 'items' | 'campaigns';

export function ReportsView() {
  const [report, setReport] = useState<ReportKey>('rates');
  return (
    <div className="space-y-4" data-testid="lms-reports">
      <SegmentedTabs
        label="Reports"
        value={report}
        onChange={(v) => setReport(v as ReportKey)}
        tabs={[
          { value: 'rates', label: 'Completion rates' },
          { value: 'items', label: 'Item analysis' },
          { value: 'campaigns', label: 'Campaign outcomes' },
        ]}
      />
      {report === 'rates' ? <CompletionRatesPanel /> : null}
      {report === 'items' ? <ItemAnalysisPanel /> : null}
      {report === 'campaigns' ? <CampaignReportPanel /> : null}
    </div>
  );
}

export default ReportsView;
